// extracted by mini-css-extract-plugin
module.exports = {"main":"Confirm_main__1Y68q","btnArea":"Confirm_btnArea__35KbZ","header":"Confirm_header__1zXRv","okBtn":"Confirm_okBtn__1Ftmi"};